<template>
  <v-container fluid ma-0 pa-0>
    <v-layout justify-center align-center >
      <v-flex xs12 sm8 ma-5 style="max-width:650px">
        <Panel :title="panelTitle">
          <div class="px-5" style="font-size: 20px">
            No commitments or contracts, no credit card information - 100% free!
          </div>
          <v-container fluid pa-5 grid-list-md>
            <v-layout justify-center wrap>
              <form v-on:keyup.enter="register">
                  <v-layout justify-center align-start>
                    <v-flex>
                      <v-layout row wrap >
                        <v-flex xs12 mb-4 v-if="error">
                          <v-alert
                            :value="error"
                            type="error"
                            outline
                          >
                            {{ error }}
                          </v-alert>
                        </v-flex>
                        <v-flex xs12 my-1>
                          <v-text-field
                            outline
                            color="secondary"
                            label="Email Address"
                            v-model="username"
                            :rules="[rules.required]"
                            tabindex="1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 my-1>
                          <v-text-field
                            outline
                            color="secondary"
                            label="Password"
                            type="password"
                            v-model="password"
                            :rules="[rules.required]"
                            tabindex="2"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 my-1>
                          <v-text-field
                            outline
                            color="secondary"
                            label="First Name"
                            v-model="firstname"
                            :rules="[rules.required]"
                            tabindex="3"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 my-1>
                          <v-text-field
                            outline
                            color="secondary"
                            label="Last Name"
                            v-model="lastname"
                            :rules="[rules.required]"
                            tabindex="4"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 my-1>
                          <v-text-field
                            outline
                            color="secondary"
                            label="School"
                            v-model="school"
                            :rules="[rules.required, rules.simpleNameRule]"
                            tabindex="5"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 my-1>
                          <v-combobox
                            outline
                            color="secondary"
                            label="Role"
                            v-model="role"
                            :items="['Teacher',
                              'Principal',
                              'Math Coordinator',
                              'Technology Coordinator',
                              'Other']"
                            :rules="[rules.required]"
                            tabindex="6"
                          ></v-combobox>
                        </v-flex>
                        <v-flex xs12 sm6 my-1>
                          <v-combobox
                            outline
                            color="secondary"
                            label="Country"
                            v-model="country"
                            :items="['Australia','Canada','Denmark','Finland','France','Germany','Mexico','New Zealand','Norway','Singapore','Sweden','Switzerland','United Kingdom','United States','Other']"
                            :rules="[rules.required]"
                            tabindex="7"
                          ></v-combobox>
                        </v-flex>
                        <v-flex xs12 sm6 my-1 v-if="country === 'United States'">
                          <v-text-field
                            outline
                            color="secondary"
                            label="Zip Code"
                            v-model="zipcode"
                            tabindex="8"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 text-xs-center>
                          <v-btn
                            large
                            v-if="!loading"
                            color="secondary"
                            style="transform: scale(1.2)"
                            @click="register">Start Free Trial
                          </v-btn>
                          <v-progress-circular
                            v-if="loading"
                            indeterminate
                            color="secondary"
                          ></v-progress-circular>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </form>
            </v-layout>
          </v-container>
        </Panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Panel from '@/components/Panel'
import AuthenticationService from '@/services/AuthenticationService'
import LicensingService from '@/services/LicensingService'

export default {
  data () {
    return {
      panelTitle: 'Free 30 Day Trial',
      error: null,
      loading: null,
      username: null,
      password: null,
      firstname: null,
      lastname: null,
      school: null,
      country: 'United States',
      zipcode: null,
      role: 'Teacher',
      rules: {
          required: value => {
            if (value) {
              return !!(value.trim()) || 'Required.'
            }
            return 'Required.'
          },
          simpleNameRule: str => {
            const pattern = /^[A-Za-z0-9 ]+$/

            return pattern.test(str) || 'School can only contain letters, numbers, and spaces.'
          }
      }
    }
  },
  components: {
    Panel
  },
  mounted: function () {
    if(this.$route.name === 'h2mregister') {
      this.$store.dispatch('setVendor', 'hand2mind')
      this.panelTitle = "Free 60 Day Trial"
    }
  },
  methods: {
    async register () {
      this.error = null
      this.loading = true
      const h2m = this.$route.name === 'h2mregister'


      const payload = {
        username: this.username.trim(),
        password: this.password.trim(),
        firstname: this.firstname.trim(),
        lastname: this.lastname.trim(),
        school: this.school.trim(),
        role: this.role,
        country: this.country,
        vendor: h2m ? 'hand2mind' : null
      }

      if (this.zipcode !== '') payload.zipcode = this.zipcode

      try {
        const response = await AuthenticationService.register(payload)
        //
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        //request the trial
        const licenseResponse = await LicensingService.issueTrialLicense({
          vendor: h2m ? 'hand2mind' : null
        })

        this.$router.push({
          path: '/verify'
        })
      } catch(err) {
        this.error = err.response.data.error
      }

      this.loading = false
    }
  }
}
</script>

<style scoped>
.registerBox {
  background: white;
  border-radius: 16px;
}

.form-error {
  color: red;
}
</style>
